import type { Money } from '@vsf-enterprise/commercetools-types';

export default (money: Money): number => {
  const divider = Math.pow(10, money?.fractionDigits);

  return money ? money?.centAmount / divider : 0;
};
